// extracted by mini-css-extract-plugin
export var divider = "_xf-0";